import React from 'react';

const California = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        California Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Transfer Disclosure Statement (TDS) and Natural Hazard Disclosure
          Report required.
        </li>
        <li>
          Natural Hazard Disclosure: Required in areas prone to natural
          disasters.
        </li>
        <li>
          Transfer Disclosure Statement: Mandatory for most residential
          transactions.
        </li>
        <h1 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
          Notice of Your ‘Supplemental’ Property Tax Bill
        </h1>
        <li>
          California property tax law requires the Assessor to revalue real
          property at the time the ownership of the property changes. Because of
          this law, you may receive one or two supplemental tax bills, depending
          on when your loan closes.The supplemental tax bills are not mailed to
          your lender. If you have arranged for your property tax payments to be
          paid through an impound account, the supplemental tax bills will not
          be paid by your lender. It is your responsibility to pay these
          supplemental bills directly to the Tax Collector. If you have any
          question concerning this matter, please call your local Tax
          Collector’s Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://www.cdph.ca.gov/Programs/CCDPHP/DEODC/CLPPB/CDPH%20Document%20Library/ResEnviroHaz2011.pdf',
                '_blank'
              );
            }}
          >
            Environmental Hazards Pamphlet{' '}
          </span>{' '}
          – The buyer must receive a copy of this pamphlet.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Homeowners-Guide-to-Earthquake-Safety.pdf',
                '_blank'
              );
            }}
          >
            Homeowner's Guide to Earthquake Safety{' '}
          </span>{' '}
          – Required to be given to the buyer.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Must accompany any purchase agreement about the sale of a property
          built before 1978.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/California-Local-Option-Real-Estate-Transfer-Statement.pdf',
                '_blank'
              );
            }}
          >
            Local Option Real Estate Transfer Statement{' '}
          </span>{' '}
          – Only complete if the local jurisdiction requires it.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/California-Megans-Law-Disclosure.pdf',
                '_blank'
              );
            }}
          >
            Megan's Law Disclosure{' '}
          </span>{' '}
          – The buyer must be provided with the necessary information to search
          the surrounding area for sex offenders.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/08/California-Natural-Hazard-Disclosure-Statement.pdf',
                '_blank'
              );
            }}
          >
            Natural Hazard Disclosure Statement{' '}
          </span>{' '}
          – Seller must complete if the property is near any natural hazardous
          area.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/08/California-Natural-Hazard-Disclosure-Statement.pdf',
                '_blank'
              );
            }}
          >
            Transfer Disclosure Statement (TDS){' '}
          </span>{' '}
          – Specific form required by law to be completed by the seller of a
          residential property.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/10/California-Death-On-Premises-Disclosure-Form.pdf',
                '_blank'
              );
            }}
          >
            Death on Premises Disclosure{' '}
          </span>{' '}
          – A landlord must disclose to a prospective buyer if a death occurred
          in the unit less than three years before the buyer offers to purchase
          the unit. This does not apply if a previous occupant had HIV or died
          from AIDS-related complications.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/California-Water-Heater-and-Smoke-Detector-Compliance-Disclosure.pdf',
                '_blank'
              );
            }}
          >
            Water Heater and Smoke Detector Compliance{' '}
          </span>{' '}
          – To inform a buyer that the smoke detector and water heater comply
          with State law.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Water-Conserving-Fixtures-and-Detector-Notice.pdf',
                '_blank'
              );
            }}
          >
            Water-Conserving Fixtures and Detector Notice{' '}
          </span>{' '}
          – To inform the buyer about water-conserving fixtures that need to be
          replaced in construction and the status of carbon monoxide detectors.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Water-Conserving-Fixtures-and-Detector-Notice.pdf',
                '_blank'
              );
            }}
          >
            Wood Destroying Pests and Organisms Inspection Report{' '}
          </span>{' '}
          – To be given to the buyer after the inspection is complete.
        </li>
      </ol>
    </div>
  );
};

export default California;
